import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ApplicationService } from '../../../../services/application/application.service';
import { ApplicationResponse } from '../../../../models/applicationResponse';
import { SharedService } from '../../../../services/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-application-details',
  templateUrl: './application-details.component.html',
  styleUrl: './application-details.component.css',
  imports: [RouterLink, CommonModule]
})
export class ApplicationDetailsComponent implements OnInit {
  application: ApplicationResponse | null = null;
  showSpinner = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private applicationService: ApplicationService,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    const appId = this.route.snapshot.paramMap.get('id');
    if (appId) {
      this.applicationService.getApplicationById(appId).subscribe({
        next: (app) => {
          this.application = app;
          this.showSpinner = false;
          console.log(this.application);
        },
        error: (err) => {
          this.showSpinner = false;
          console.error('Fehler beim Abrufen der Bewerbungsdetails:', err);
          this.sharedService.handleError(err, 'error', 'Fehler beim Laden der Bewerbungsdetails. Bitte versuchen Sie es erneut.');
          this.router.navigate(['/Admin/applications']);
        }
      });
    } else {
      this.sharedService.handleError(null, 'error', 'Ungültige Bewerbungs-ID.');
      this.router.navigate(['/applications']);
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'pending':
        return 'badge-pending';
      case 'reviewed':
        return 'badge-reviewed';
      case 'accepted':
        return 'badge-accepted';
      case 'rejected':
        return 'badge-rejected';
      default:
        return 'badge-secondary';
    }
  }
}